import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function FarmacovigilanciaPrivilegios({ user, permissions, setPermissions }) {
  return (
    <>
      <Header header={'Farmacovigilancia'} />

      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'farmacovigilanciaAnalise'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Notificação processo em Análise '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'farmacovigilanciaChefeArea'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Notificação processo em Chefe de Área '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'farmacovigilanciaChefeDepartamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Notificação processo em Chefe de Departamento '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'farmacovigilanciaInspeccao'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Notificação processo na Inspecção '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'farmacovigilanciaControloQualidade'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Notificação processo em Controlo de Qualidade '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'farmacovigilanciaDirectoraGeralAdjunta'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Notificação processo em Directora Geral Adjunta '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'farmacovigilanciaDirectorGeral'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Notificação processo em Director Geral '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'reclamacoesFarmacovigilancia'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Gestão de Reclamações em Farmacovigilância '}
                  descricao={''}
                />
              , editable: false,
            },

          ]} />

    </>
  )
}
